import script from "./CodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeView.vue?vue&type=script&setup=true&lang=js"

import "./CodeView.vue?vue&type=style&index=0&id=16f29fac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f29fac"]])

export default __exports__